module.exports = (__webpack_require__(0))(44);


//////////////////
// WEBPACK FOOTER
// delegated ./src/models/ItemModel.js from dll-reference girder_lib
// module id = 53
// module chunks = 0